module.exports = __webpack_public_path__ + "static/media/heydoor_word_white.cb731723.png";